<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>下单IP设备查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input
          placeholder="请输入用户ID"
          clearable
          v-model="userId"
          class="filter-input"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="platform"
          placeholder="设备类型"
          clearable
          class="filter-select"
        >
          <el-option value="" label="全部类型"></el-option>
          <el-option
            v-for="item in platformOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="value1"
          type="daterange"
          align="right"
          format="yyyy-MM-dd"
          value-format="timestamp"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        />
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <a
          class="export-link"
          :href="exportLink"
          target="_blank"
          rel="noopener noreferrer"
          >导出</a
        >
      </div>
      <user-list @refresh="refreshList" />
    </el-card>
  </div>
</template>

<script>
import './store';
import UserList from './components/list';
import { mapState, mapActions } from 'vuex';
import { PAGINATION } from './constants';
import qs from 'qs';

export default {
  name: 'userOrderLog',
  components: {
    UserList,
  },
  data() {
    return {
      userId: '',
      platform: '',
      value1: '',
      platformOptions: [
        { value: 'IPHONE', label: 'IPHONE' },
        { value: 'WEB', label: 'WEB' },
        { value: 'ANDROID', label: 'ANDROID' },
        // { value: 'H5', label: 'H5' },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('userOrderLog', ['pagination']),
    exportLink() {
      const data = {
        page: this.pagination.page,
        size: this.pagination.size,
      };
      if (this.userId !== '' && this.userId != null) {
        data.userId = this.userId;
      }
      if (this.platform) {
        data.platform = this.platform;
      }
      if (this.value1 && this.value1[0]) {
        data.startTime = this.value1[0];
      }
      if (this.value1 && this.value1[1]) {
        data.endTime = this.endOfDayTimestamp(this.value1[1]);
      }
      return `/la/admin/user/userOrderLog/export?${qs.stringify(data)}`;
    },
  },
  methods: {
    ...mapActions('userOrderLog', ['list']),
    endOfDayTimestamp(ts) {
      if (ts == null || ts === '') return '';
      const d = new Date(typeof ts === 'string' ? Number(ts) : ts);
      d.setHours(23, 59, 59, 999);
      return d.getTime();
    },
    buildQuery(extra = {}) {
      return {
        userId: this.userId,
        platform: this.platform,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.endOfDayTimestamp(this.value1[1]) : '',
        ...this.pagination,
        ...extra,
      };
    },
    refreshList(data = {}) {
      this.list(this.buildQuery(data));
    },
    handleSearch() {
      this.list(this.buildQuery({ ...PAGINATION }));
    },
  },
  created() {
    this.list(this.buildQuery({ ...PAGINATION }));
  },
};
</script>

<style lang="less" scoped>
.filter-input {
  width: 200px;
}
.filter-select {
  width: 160px;
}
.export-link {
  margin-left: 8px;
  line-height: 32px;
  vertical-align: middle;
  color: #409eff;
}
</style>
